'use client';

import { usePathname } from 'next/navigation';
import { type ReactNode } from 'react';
import { isAddEightySixPath, isMessagesPath } from '@utils/route-utils';

/** Conversations own their scroll area; other pages retain the shell gutters. */
export function AppPageContent({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const messages = isMessagesPath(pathname);
  const addEightySix = isAddEightySixPath(pathname);

  if (messages) {
    return (
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden desktop-chrome:h-[calc(100dvh-var(--app-topbar-height))] desktop-chrome:flex-none desktop-chrome:p-5">
        {children}
      </div>
    );
  }

  if (addEightySix) {
    return (
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-5 desktop-chrome:overflow-visible desktop-chrome:px-8">
        <div className="flex min-h-0 flex-1 flex-col pt-3 desktop-chrome:block desktop-chrome:flex-none desktop-chrome:pt-8 desktop-chrome:pb-8">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col px-5 desktop-chrome:px-8">
      <div className="pt-3 pb-[calc(var(--mobile-tabbar-height)+1.5rem)] desktop-chrome:pt-8 desktop-chrome:pb-8">
        {children}
      </div>
    </div>
  );
}
